import AlgoTopics from "./AlgoTopics"

export default function Algorithms()
{
    return(
        <div id="algorithms" className="pt-40 pb-40 flex flex-col justify-center items-center">
            <h2 className="text-4xl mb-20 text-center">Algorithms</h2>
            <AlgoTopics/>
        </div>
    )
}